/**
 * Notification group/subject
 */
export enum NotificationKindEnum {
  TASK = 'TASK',
  DEAL = 'DEAL',
  PROJECT = 'PROJECT',
  HELPDESK = 'HELPDESK',
  PERSONAL = 'PERSONAL',
  PURCHASE = 'PURCHASE',
  PASSAGE = 'PASSAGE',
  DEBT = 'DEBT',
}
